import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "./store/store";
import App from "./App";
import { ConfigProvider } from "antd";
import "./assets/styles/style.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
    throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <ConfigProvider
                theme={{
                    token: {
                        colorPrimary: "#0ea5e9",
                        borderRadius: 12,
                        fontSize: 14,
                        lineHeight: 1.6,
                        controlHeight: 40,
                        padding: 8,
                        fontFamily: "Poppins, sans-serif",
                    },
                    components: {
                        Alert: {
                            defaultPadding: "6px 10px",
                            withDescriptionPadding: "8px 10px",
                            // withDescriptionIconSize: 16,
                        },
                        Dropdown: {
                            // colorBgElevated: "#4f46e5",
                        },
                        Menu: {
                            itemBg: "#ffffff",
                            itemColor: "#374151",

                            itemHoverBg: "#f3f0ff", // hover bg
                            itemHoverColor: "#4f46e5", // hover text

                            itemSelectedBg: "#ede9fe",
                            itemSelectedColor: "#4f46e5",

                            borderRadius: 8,
                        },
                        Select: {
                            optionSelectedBg: "#f3f0ff", // selected option bg
                            optionActiveBg: "#f3f0ff", // hover bg
                            optionSelectedColor: "#4f46e5", // selected text
                        },
                        Pagination: {
                            itemBg: "#ffffff",
                            itemActiveBg: "#ede9fe", // active page bg
                            itemActiveColor: "#4f46e5",
                            // colorText: "#374151", // default text
                            colorPrimary: "#4f46e5", // primary (hover text)
                            colorBgTextHover: "#f3f0ff",
                        },
                        Tooltip: {
                            colorBgSpotlight: "#ffffff",
                            colorTextLightSolid: "#374151",
                        }
                    },
                }}
            >
                <App />
            </ConfigProvider>
        </Provider>
    </React.StrictMode>,
);
